import { render, staticRenderFns } from "./CardNavixySinContract.vue?vue&type=template&id=54117b2c&"
import script from "./CardNavixySinContract.vue?vue&type=script&lang=js&"
export * from "./CardNavixySinContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports